import React, { useEffect, useState } from 'react';

import { auth } from '../apis/firebase';
import { onAuthStateChanged } from 'firebase/auth';




const AuthContext = React.createContext();

export function useAuth() {
  return React.useContext(AuthContext);
}


export function AuthProvider({children}) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(true);

  useEffect(() => { 
    const unsubscribe = onAuthStateChanged(auth, initUser);
    return unsubscribe;
  }, []);

 async function initUser(user) {
  if (user) {
    setUser({...user});
   
    setLoggedIn(true);
  } else {
    setUser(null);
    setLoggedIn(false);
  }
  setLoading(false);
  
 }

 const value = {
  user,
  loggedIn,
  loading
 }

 return (
  <AuthContext.Provider value={value}>
    {!loading && children}
  </AuthContext.Provider>
 )


}